export default __webpack_public_path__ + "static/media/logo_h.c6e3c65d.png";